import React from "react";

import Tooltip from "@material-ui/core/Tooltip";

import {ReactComponent as DevelopingIconSmall} from "./developing.svg";
import {ReactComponent as ExpertApprovingIconSmall} from "./expert_approving.svg";
import {ReactComponent as ExpertApprovedIconSmall} from "./expert_approved.svg";
import {ReactComponent as RejectedIconSmall} from "./rejected.svg";
import {ReactComponent as PublishingIconSmall} from "./publising.svg";
import {ReactComponent as PublishedIconSmall} from "./published.svg";

const lookup = [
  {
    value: 1,
    text: "В разработке"
  },
  {
    value: 2,
    text: "На экспертизе"
  },
  {
    value: 3,
    text: "Одобрено экспертом"
  },
  {
    value: 4,
    text: "Отклонено"
  },
  {
    value: 5,
    text: "На публикации"
  },
  {
    value: 6,
    text: "Опубликовано"
  }
];

function expertiseStatusExcelCell(options, column, gridCell) {
  if (gridCell.value === 1) {
    options.value = "В разработке";
  } else if (gridCell.value === 2) {
    options.value = "На экспертизе";
  } else if (gridCell.value === 3) {
    options.value = "Одобрено экспертом";
  } else if (gridCell.value === 4) {
    options.value = "Отклонено";
  } else if (gridCell.value === 5) {
    options.value = "На публикации";
  } else if (gridCell.value === 6) {
    options.value = "Опубликовано";
  }
}

function expertiseStatusCell(config) {
  config.cellRender = ExpertiseStatusCell;
  config.dataType = "number";
  config.alignment = "center";
  config.lookup = {
    dataSource: lookup,
    valueExpr: "value",
    displayExpr: "text"
  }
}

const ExpertiseStatusCell = (cellData) => {
  switch (cellData.value) {
    case 1:
      return (
        <div>
          <Tooltip title="В разработке">
            <DevelopingIconSmall/>
          </Tooltip>
        </div>
      );
    case 2:
      return (
        <div>
          <Tooltip title="На экспертизе">
            <ExpertApprovingIconSmall/>
          </Tooltip>
        </div>
      );
    case 3:
      return (
        <div>
          <Tooltip title="Одобрено экспертом">
            <ExpertApprovedIconSmall/>
          </Tooltip>
        </div>
      );
    case 4:
      return (
        <div>
          <Tooltip title="Отклонено">
            <RejectedIconSmall/>
          </Tooltip>
        </div>
      );
    case 5:
      return (
        <div>
          <Tooltip title="На публикации">
            <PublishingIconSmall/>
          </Tooltip>
        </div>
      );
    case 6:
      return (
        <div>
          <Tooltip title="Опубликовано">
            <PublishedIconSmall/>
          </Tooltip>
        </div>
      );
    default:
      return null;
  }
};


export {expertiseStatusCell, expertiseStatusExcelCell}
